import React, { forwardRef, useRef, useState } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import { Checkbox } from './Checkbox';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

const MultiDropdown = ({ value = [], onChange, placeholder, label, options = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const detailsRef = useRef(null);

  const toggleValue = (val) => {
    if (!onChange) return;
    if (value.includes(val)) {
      onChange(value.filter((v) => v !== val));
    } else {
      onChange([...value, val]);
    }
  };

  const selectedLabels =
    value.length > 0
      ? options
          .filter((opt) => value.includes(opt.value))
          .map((o) => o.label)
          .join(', ')
      : placeholder;

  return (
    <div ref={selectRef} className="relative z-20">
      <p className={'block text-gray-700 text-sm ml-2 mb-2'}>{label}</p>
      <details ref={detailsRef} onToggle={(e) => setIsOpen(e.currentTarget.open)} className="w-full">
        <summary className="flex justify-between items-center cursor-pointer border border-gray-300 rounded-full pl-4 pr-2 py-2 bg-white">
          <span className={`truncate ${!value.length ? 'text-gray-400' : ''}`}>{selectedLabels}</span>
          {isOpen ? <KeyboardArrowUp className="text-gray-500" color="inherit" /> : <KeyboardArrowDown className="text-gray-500" color="inherit" />}
        </summary>

        <div className="mt-2 border border-gray-300 rounded-xl bg-white p-3 max-h-60 overflow-y-auto">
          {options.map((option) => (
            <Checkbox
              key={option.value}
              labelClassName={'text-gray-700'}
              label={option.label}
              checked={value.includes(option.value)}
              onChange={() => toggleValue(option.value)}
            />
          ))}
        </div>
      </details>
    </div>
  );
};

const ControlledMultiDropdown = forwardRef(({ name, rules, defaultValue, classContainer, options, ...restProps }, ref) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);

  return (
    <Controller
      control={control}
      name={name ?? ''}
      rules={rules}
      defaultValue={defaultValue || []}
      render={({ field }) => (
        <div className={`relative ${classContainer || ''}`}>
          <MultiDropdown {...field} {...restProps} options={options} ref={ref} />
          {error && <span className="absolute bottom-[-16px] text-xs text-red-500">*{error?.message}</span>}
        </div>
      )}
    />
  );
});

ControlledMultiDropdown.displayName = 'ControlledDropdown';
export default ControlledMultiDropdown;
